import React, { useEffect, useState } from 'react';
import { fetchBulkPaymentTransferProcessTags, fetchBulkPaymentTransferRequests } from './utils';
import DownloadTemplate from './DownloadTemplate';
import { bulkTransferTypes, EMPTY_FILTER_FORM } from './constants';
import UploadTransferFile from './UploadTranferFile';
import Filters from './Filters';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import ALoader from '../../views/pages/manage/common/a-loader';
import { useHistory } from 'react-router-dom';
import BulkPaymentTransferRequestsList from './BulkPaymentTransferRequestsList';
import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils';
import { getAllActivePaymentMode } from 'views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/utils';


const BulkPaymentTransfer = ({
    userPermissions
}) => {

    const history = useHistory();

    // Map transfer type values to their corresponding permission flags
    const permissionMap = {

    };

    const [bulkPaymentTransferProcessTag, setBulkPaymentTransferProcessTag] = useState([]);
    const [bulkPaymentTransferRequests, setBulkPaymentTransferRequests] = useState({ loading: false, data: [] });
    const [paginationInfo, setPaginationInfo] = useState({
        currPageNo: 0,
        currPageSize: 50,
        totalRecords: 0
    })
    const [filterForm, setFilterForm] = useState(EMPTY_FILTER_FORM);
    const [loading, setLoading] = useState(false);
    const [paymentModeDropdown, setPaymentModeDropdown] = useState([]);


    const handleFilterForm = (key, val) => setFilterForm(prev => ({ ...prev, [key]: val }));

    const getBulkPaymentTransferRequestsList = async ({
        filters = filterForm,
        offset = paginationInfo?.currPageNo,
        pageSize = paginationInfo?.currPageSize,
    }) => {
        try {
            setBulkPaymentTransferRequests(prev => ({ ...prev, loading: true }));
            const resp = await fetchBulkPaymentTransferRequests({ filters, offset, pageSize });
            const { totalRecords, paymentTransferBulkFileDetailsList, currentPage,totalPage } = resp?.data;
            setBulkPaymentTransferRequests(prev => ({ ...prev, data: paymentTransferBulkFileDetailsList })); 
            setPaginationInfo(prev => ({
                ...prev,
                totalRecords,
                currPageNo: currentPage,
                currPageSize: pageSize,
                totalPage
            }))


            setFilterForm({
                ...filters,
                appliedFilterCount: getAppliedFilterCount(filters)
            });

        } catch (err) {
            console.error(err);
        } finally {
            setBulkPaymentTransferRequests(prev => ({ ...prev, loading: false }));

        }

    }

    const init = async () => {
        try {
            const allowedLabels = ["ADJ", "SDJ", "CMP"];
            setLoading(true);
            const [allActiveProcessTags, paymentModes, resList] = await Promise.all([fetchBulkPaymentTransferProcessTags(), getAllActivePaymentMode(), getBulkPaymentTransferRequestsList({})]);
            const filteredPaymentModes = (paymentModes?.filter((mode) => allowedLabels.includes(mode.label.toUpperCase()))).map((mode) => ({ label: mode.label, value: mode.label }));
            // Build permitted list from active process tags (keep processTag objects)
            const processTagDetail = (allActiveProcessTags || []).find(processTag => processTag?.tagTypeKey == "PAYMENT_TRANSFER_BULK_UPLOAD");
            setBulkPaymentTransferProcessTag(processTagDetail);
            setPaymentModeDropdown(filteredPaymentModes);
            setLoading(false);
        }
        catch (err) {
            console.error(err);
            setLoading(false);
        }


    }

    useEffect(() => {
        init()
    }, [])


    return (
        <div className='a-card'>
            {loading && <ALoader position={"fixed"} zIndex={120} />}

            {/* card Header  */}
            <div className='d-flex justify-content-between mb-3'>

                <div className='d-flex align-items-center'>
                    <BackArrow className='mr-2 cursor' onClick={() => history.goBack()} />

                    <h3 className='mb-0'>Bulk Payment Transfer</h3>
                </div>



                <div className='d-flex'>
                    <Filters
                        filterForm={filterForm}
                        handleFilterForm={handleFilterForm}
                        getBulkTransferRequestsList={getBulkPaymentTransferRequestsList}
                        paymentModeDropdown={paymentModeDropdown}
                    />

                    {userPermissions.includes("B") && bulkPaymentTransferProcessTag && <DownloadTemplate
                        permittedBulkPaymentTransferTypes={bulkPaymentTransferProcessTag}
                        setLoading={setLoading}
                    />}

                    {userPermissions.includes("B") && bulkPaymentTransferProcessTag && <UploadTransferFile
                        bulkPaymentTransferProcessTag={bulkPaymentTransferProcessTag}
                        setLoading={setLoading}
                        getBulkTransferRequestsList={getBulkPaymentTransferRequestsList}
                        paymentModeDropdown={paymentModeDropdown}
                    />}
                </div>
            </div>
            <BulkPaymentTransferRequestsList
                rows={bulkPaymentTransferRequests?.data || []}
                paginationInfo={paginationInfo}
                getBulkPaymentTransferRequestsList={getBulkPaymentTransferRequestsList}
                userPermissions={userPermissions}
            />

        </div>
    );
}

export default BulkPaymentTransfer;